import { Col, Row } from '../../ui'
import { Container } from './styles'
import { getToken } from 'infra/services/auth'
import { Link, useLocation, useHistory } from 'react-router-dom'
import LogoHeader from '../../../assets/novoLogoOnfarmRumina.png'
import { translate } from './../../../../i18n/index'
import { AddCircle } from '@mui/icons-material'
import ActionWhatsApp from './steps/action-whatsApp'
import ActionHelperType from './steps/action-helper-type'
import NotificationMenu from '../../ui/notification-menu/notification-menu'
import UserMenu from '../../ui/user-menu/user-menu'
import HeaderDetails from './steps/header-details'
import ActionButton from './steps/action-button'
import ActionMenuIntegracao from './steps/action-menu-integracao'

const BaseLayout = ({ children }) => {
  const location = useLocation()
  const token = getToken()
  const history = useHistory()

  return (
    <Container>
      {token &&
        <div>
          <Row className='headerMain'>
            <div>
              <Col width={80} className='headerLeft'>
                <div className='divLogo'>
                  <img src={LogoHeader} alt="icone de seta para baixo" />
                </div>
                <div className='divActions'>
                  <ActionButton pathname={'/rastreio-de-pedidos'} name={translate('labelRastreioPedidos')} />
                  <ActionButton pathname={'/lactacao'} name={translate('labelVacasLactacao')} />
                  <ActionMenuIntegracao />
                  <ActionButton pathname={'/central-de-notificacoes'} name={translate('labelCentralNotificacao')} />
                  <Link to={{ pathname: '/ubere-lancamento', state: history.location.pathname }} className='headerButtonLancamento' >
                    <AddCircle style={{ color: '#fff', fontSize: 20 }} />
                    <span >Lançamento</span>
                  </Link>
                </div>
              </Col>
              <Col width={20} className='headerRight'>
                <ActionWhatsApp />
                <ActionHelperType />
                <NotificationMenu />
                <UserMenu />
              </Col>
            </div>
          </Row>
          {
            location.pathname !== '/' && (
              <HeaderDetails />
            )
          }
        </div>
      }
      {children}
    </Container>
  )
}

export default BaseLayout
